export const ID_REGEXP = /^\d+/;
export const LOCALE_REGEXP = /\/[a-z]{2}(?:-[a-z]{2})?(?=(?:\/|$))/gi;
export const PRODUCT_RANGE_SEGMENT = 'product-range/';
export const RANGE_ENDPOINT = 'product/';
